import { makeRequest } from 'utils/requestLogger';

export default (id, courses) =>
  makeRequest('post', `/api/courses/${id}/import-feedback-online`, { courses });



// WEBPACK FOOTER //
// ./src/app/services/courses/importFeedbackOnline.js